import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock, Loader2 } from "lucide-react";
import { api, setToken, formatApiError } from "../lib/api";
import { LOGO_URL } from "../data/content";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setToken(data.access_token);
      navigate("/admin");
    } catch (e2) {
      setError(formatApiError(e2.response?.data?.detail, "Connexion impossible."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center bg-[#0B0E17] px-5 text-[#FDFBF7]">
      <div className="light-rays -z-10 opacity-30" />
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="glass w-full max-w-md rounded-3xl p-9"
      >
        <div className="text-center">
          <img src={LOGO_URL} alt="Logo" className="mx-auto h-16 w-16 object-contain" />
          <h1 className="mt-5 font-heading text-3xl font-light">Espace administrateur</h1>
          <p className="mt-2 font-body text-sm text-[#A1A9C3]">
            Connectez-vous pour consulter les candidatures.
          </p>
        </div>

        {error && (
          <div
            data-testid="login-error"
            className="mt-6 rounded-xl border border-red-500/40 bg-red-500/10 px-4 py-3 font-body text-sm text-red-200"
          >
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="mt-7 space-y-4">
          <div>
            <label className="mb-1 block font-body text-xs uppercase tracking-[0.14em] text-[#A1A9C3]">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email-input"
              required
              className="w-full rounded-xl border border-[#D4AF37]/20 bg-[#0B0E17]/60 px-4 py-3 font-body text-[#FDFBF7] outline-none focus:border-[#D4AF37]"
            />
          </div>
          <div>
            <label className="mb-1 block font-body text-xs uppercase tracking-[0.14em] text-[#A1A9C3]">
              Mot de passe
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password-input"
              required
              className="w-full rounded-xl border border-[#D4AF37]/20 bg-[#0B0E17]/60 px-4 py-3 font-body text-[#FDFBF7] outline-none focus:border-[#D4AF37]"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit-button"
            className="flex w-full items-center justify-center gap-2 rounded-full bg-[#D4AF37] px-7 py-3.5 font-body font-semibold text-[#0B0E17] transition-all hover:bg-[#e6c451] disabled:opacity-60"
          >
            {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <Lock className="h-4 w-4" />}
            {loading ? "Connexion…" : "Se connecter"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
